// extracted by mini-css-extract-plugin
module.exports = {"passwordIcon":"Form_passwordIcon__YrGIr","keepMeSigned":"Form_keepMeSigned__3hOGq","signInBtn":"Form_signInBtn__3OG0W"};